import React from "react";
import PropTypes from "prop-types";
import logger from "../utils/logger";
import { isRecoverableChunkLoadError } from "../utils/chunkLoadError";
import { reloadAppForUpdate } from "../serviceWorkerRegistration";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    const isChunkError = isRecoverableChunkLoadError(error);

    logger.error("AppErrorBoundary caught runtime error", error, {
      error_meta: {
        action: "app_runtime_boundary",
        recoverable: isChunkError,
      },
      app_context: {
        module: "AppErrorBoundary",
        route: window.location.pathname,
        componentStack: errorInfo?.componentStack,
      },
    });

    if (isChunkError) {
      reloadAppForUpdate({ reason: "app_chunk_error" });
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { error } = this.state;

    if (error) {
      const isChunkError = isRecoverableChunkLoadError(error);

      return (
        <div className="min-h-screen bg-[var(--color-bg-primary)] px-6 py-10">
          <div className="mx-auto flex min-h-[calc(100vh-5rem)] max-w-md items-center justify-center">
            <div className="w-full rounded-3xl border border-[var(--color-border)] bg-[var(--color-bg-secondary)] p-6 text-center shadow-xl">
              <div className="text-xl font-black tracking-tight text-[var(--color-text-primary)]">
                {isChunkError
                  ? "Приложение нужно обновить"
                  : "Приложение столкнулось с ошибкой"}
              </div>
              <p className="mt-3 text-sm font-medium leading-relaxed text-[var(--color-text-secondary)]">
                {isChunkError
                  ? "Мы попытались восстановить приложение после обновления. Если экран не обновился автоматически, перезапустите его вручную."
                  : "Во время запуска произошла ошибка. Обновите приложение и повторите попытку."}
              </p>
              <button
                type="button"
                onClick={this.handleReload}
                className="mt-5 inline-flex h-11 items-center justify-center rounded-xl bg-[var(--color-primary)] px-5 text-sm font-black text-white shadow-lg shadow-blue-500/20 transition-transform hover:scale-[1.01] active:scale-[0.99]"
              >
                Перезапустить приложение
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

AppErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppErrorBoundary;
